export default "__VITE_ASSET__XHOt80pK__"